import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import styles from './TextArea.module.scss';
export type TextAreaProps = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'className' | 'style'> & {
  className?: never;
  style?: never;
};

/**
 * A multi-line text input on the Helios field look: four rows by default,
 * resizable vertically only. The error state is `aria-invalid` (FormGroup
 * sets it).
 */
const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(t0, ref) {
  const $ = _c(8);
  let props;
  let t1;
  if ($[0] !== t0) {
    const {
      rows: t2,
      className: _className,
      style: _style,
      ...t3
    } = t0;
    t1 = t2;
    props = t3;
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const rows = t1 === undefined ? 4 : t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = classNames(styles["helios-text-area"]);
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== ref || $[6] !== rows) {
    t3 = <textarea {...props} ref={ref} rows={rows} data-helios-control="textarea" className={t2} />;
    $[4] = props;
    $[5] = ref;
    $[6] = rows;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
});
export default TextArea;